import { Injectable } from '@angular/core';
import { QueuesState, QUEUES_STATE } from '@shared/models/queues/queues.model';
import { Observable, of } from 'rxjs';
import { AppStorageService } from './app-storage.service';

@Injectable({
  providedIn: 'root',
})
export class QueuesSharedService {
  public updateQueuesStateInComponent = true;

  constructor(private appStorage: AppStorageService) {}

  refreshQueuesStateInStorage(): Observable<boolean> {
    this.updateQueuesStateInComponent = false;
    const queuesState: QueuesState = this.appStorage.getItem(QUEUES_STATE);
    if (queuesState) {
      this.appStorage.setItem(QUEUES_STATE, { ...queuesState, filters: {} });
    }
    return of(true);
  }
}
